export default __webpack_public_path__ + "static/media/usd.1044184a.webp";